import React from 'react';
import { Navigate } from 'react-router-dom';
import { EnhancedRouteProps } from '../../../../routes/Enhanced/Enhanced.route';
import Reports from './pages/Reports';
import Overview from './pages/Overview';

export default [
  {
    path: 'overview',
    element: Overview,
  },
  {
    path: 'activity-log',
    element: Reports,
  },
  {
    index: true,
    element: <Navigate to="overview" replace />,
  },
] as Array<EnhancedRouteProps>;
